module.exports = __webpack_public_path__ + "img/crp.5c480f0c.jpg";